import {
  TOrderInputType,
} from './pt9800-loading-place';

const orderInputType: Record<TOrderInputType, string> = {
  keyboard: 'Keyboard',
  scanner: 'Scanner',
};

export default {
  orderInputType,
  orderInputlabel: 'Order input type',
  loadingPlace: 'Loading place',
  orderInput: 'Order',
  priority: 'Priority',
  processFlowNo: 'Process flow No.',
  box: 'Box',
  cellChargeNo: 'Cell charge No.',
  comment1: 'Comment 1',
  comment2: 'Comment 2',
  comment3: 'Comment 3',
  placeStatus: 'Place status',
  locked: 'locked',
  loadBookedAndReady: 'Load is booked and ready',
  enableLoadForAutomatic: 'Enable load for Automatic',
  loadbookingEnded: 'Loadbooking has ended',
  camera: 'Camera',
  noOrderLoaded: 'No order loaded',
};
